import { RESET_STATE } from 'store/global/actions';

import { LOAN_HEADER_VIEW_ACTION_TYPE } from '../actions';

const initialState = [];

const companyDefaultHeaderViewsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_HEADER_VIEW_ACTION_TYPE.GET_COMPANY_DEFAULT_HEADER_VIEWS:
      return payload ?? initialState;
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default companyDefaultHeaderViewsReducer;
